import { PaymentStatus } from './payment.status.enum';
import { EtatEcriture } from './etatEcriture.enum';

export class Panier {
  DetailPanier: DetailPanier[];
  TotalPanier: TotalPanier;

  constructor(detailPanier: DetailPanier[], totalPanier: TotalPanier) {
    this.DetailPanier = detailPanier;
    this.TotalPanier = totalPanier;
  }

  static extractPanier(response: PanierResponse): Panier {
    return new Panier(response.DetailPanier, response.TotalPanier);
  }
}

export class PanierResponse {
  DetailPanier: DetailPanier[];
  TotalPanier: TotalPanier;
  OrderStatus: PaymentStatus;
  PanierStatut: PanierStatut;
}

export class DetailPanier {
  IdPieceComptable: number;
  Id: string | null;
  TypePiece: number;
  NumPiece: string;
  DateCreation: Date;
  DateEcheance: Date;
  Montant: number;
  MontantInitial: number;
  State: EtatEcriture;
  BillId: number;
  Solde: number;
  SelectedForReglement: boolean = true;
  SelectedForReglementPartial: boolean = false;
  ValeurPiece: number;
}

export class TotalPanier {
  SousTotal: number;
  Total: number;
  Tva: number;
}

export class PanierStatut {
  CanEdit: boolean;
  CanCancel: boolean;
  MustStartNew: boolean;
  HaveToCancel: boolean;
  PaymentOrderId: boolean;
}

export class PieceToAdd {
  BillId: number;
  IdPieceComptable: number;
}

export enum PanierState {
  BILLS_CHOICE,
  PAY_MEAN_CHOICE,
  PAY_IN_PROGRESS,
  PAY_SUCCESS,
  PAY_ERROR,
  PAY_CANCELED
}
